import axios, { AxiosRequestConfig } from 'axios';
import { NavigateFunction } from 'react-router-dom';
import { clearSessionCredentials } from '../../../../../../globalFunctions';
import { Feedback } from '../../../../../../types';

export const saveWelcomeFeedback = async (
    token: string,
    navigate: NavigateFunction,
    feedback: Feedback
) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.put(
            `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/feedback/${feedback.id}`,
            feedback,
            requestConfig
        );

        return response.data;
    } catch (error: any) {
        const response = {
            message: 'Erro ao atualizar saudação inicial',
            error: error
        };

        if ([401, 419].includes(error.response.status)) {
            // Unauthorized
            clearSessionCredentials(navigate);
        } else {
            console.error(response);
            return response;
        }
    }
};
